// @flow

import React from 'react';
import styled, { css } from 'styled-components/macro';
import { palette } from 'styled-theme';
import { ifProp } from 'styled-tools';

// $FlowIssue
import { ReactComponent as IconOK } from '@/icons/ic-ok.svg';

export type CheckboxProps = {
  children?: React$Node,
  disabled?: boolean,
  palette?: string,
  checked?: boolean,
  onChange?: Function,
  className?: string,
};

const backgroundColor = ({ disabled }: CheckboxProps) =>
  palette(disabled ? 3 : 1);

const CheckboxWrapper = styled.div.attrs(() => ({ testid: 'checkbox' }))`
  display: inline-flex;
  position: relative;
  transition: all 250ms ease-out;
  ${ifProp(
    'disabled',
    css`
      opacity: 0.4;
      pointer-events: none;
    `,
  )}

  label {
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    line-height: 13px;
    min-height: 26px;
  }

  input {
    display: none;
  }
`;

const CheckboxInput = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  width: 24px;
  height: 24px;
  overflow: hidden;
`;

const CheckboxOn = styled.div`
  position: relative;
  width: 18px;
  height: 18px;
  background: currentColor;
  color: ${backgroundColor};

  svg {
    position: relative;
  }

  &::before {
    content: '';
    position: absolute;
    left: 3px;
    top: 3px;
    width: 12px;
    height: 12px;
    background: #fff;
  }
`;

const CheckboxOff = styled.div.attrs(() => ({
  className: 'react-checkbox',
}))`
  width: 14px;
  height: 14px;
  border: 2px solid #b9c0c9;
  border-radius: 2px;
`;

export const Checkbox = ({
  children,
  disabled,
  checked,
  onChange,
  palette,
  className,
}: CheckboxProps) => (
  <CheckboxWrapper disabled={disabled} testid="checkbox" className={className}>
    <label>
      <input type="checkbox" checked={checked} onChange={onChange} />
      <CheckboxInput checked={checked}>
        {checked ? (
          <CheckboxOn palette={palette}>
            <IconOK />
          </CheckboxOn>
        ) : (
          <CheckboxOff />
        )}
      </CheckboxInput>
      {children}
    </label>
  </CheckboxWrapper>
);

Checkbox.defaultProps = {
  palette: 'primary',
  testid: 'checkbox',
};
